<script>
    import { createEventDispatcher, onDestroy, onMount } from 'svelte';
    export let valor
    export let titulo
    export let status='success'
    export let autoclose=0
    let interval
    const dispatch = createEventDispatcher();

    function cerrarAlert() {
		dispatch('close');
	}

    /*$: if(autoclose>0) {
        
    }*/

	onMount(async () => {
        if(autoclose>0) {
            interval = setTimeout(() => { cerrarAlert(); }, autoclose*1000);
        }
	});

    onDestroy(() => {
        if(autoclose>0) {
            clearInterval(interval)
        }
    });
    
</script>

<div class="alert alert-dismissible fade show" 
    class:alert-success={status=='success'}
    class:alert-danger={status=='danger'}
    role="alert">
    {#if status=='success'}
        <i class="bi bi-check-all"></i>
    {:else if  status=='danger'}
        <i class="bi bi-exclamation-circle-fill"/>
    {/if}
    
    <small><strong>{titulo}</strong></small>
    {valor}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" on:click={cerrarAlert}></button>
</div>